import { useCallback, useSyncExternalStore } from 'react';
import { getSetting, setSetting, subscribeSetting, type SettingDef } from './settings';

// A persisted setting as React state: reads the stored value (or the default),
// re-renders when it changes in this tab or another, and writes through.
export function useSetting<T>(def: SettingDef<T>): [T, (value: T) => void] {
    const subscribe = useCallback((listener: () => void) => subscribeSetting(def as SettingDef<unknown>, listener), [def]);
    const value = useSyncExternalStore(subscribe, () => getSetting(def));
    const set = useCallback((next: T) => setSetting(def, next), [def]);
    return [value, set];
}
